import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent, trackPageView } from '../utils/analytics';

/**
 * Sends GA4 page_view on client-side route changes when consent is granted.
 */
const AnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!hasAnalyticsConsent()) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
